import type { Address } from "viem"

import { LcAddress } from "@/domains/core"

/**
 * Normalizes chain config `bannedPairs` into a set of lowercase pool addresses for O(1) lookups.
 */
export function buildMinimalPoolBanSet(
  bannedPairs: Array<{ address: Address; reason: string }> | undefined,
): ReadonlySet<string> {
  if (bannedPairs === undefined || bannedPairs.length === 0) {
    return new Set()
  }
  const out = new Set<string>()
  for (let i = 0; i < bannedPairs.length; i++) {
    const entry = bannedPairs[i]
    if (entry) {
      out.add(new LcAddress(entry.address).toString())
    }
  }
  return out
}
